import Multi from './Multi'

export default Multi